import moderation from '@spotim/fed-resources/resources/moderation';
import { dispatch } from 'state/store';
import { codeVerificationFailed, updateVerificationStatus } from '../../../../../auth/authSlice';

export default function (context, payload, done) {
  var { spotId, code, sendCodeVerificationStatusEvent } = payload;

  dispatch(updateVerificationStatus('loading'));
  moderation
    .verifyCode(spotId, code)
    .then(
      response => {
        try {
          dispatch(updateVerificationStatus('success'));
          sendCodeVerificationStatusEvent(true);
        } catch (reason) {
          verifyCodeFailed(context, reason);
          sendCodeVerificationStatusEvent(false);
        }
      },
      reason => {
        verifyCodeFailed(context, reason);
        sendCodeVerificationStatusEvent(false);
      }
    )
    .finally(done);
}

function verifyCodeFailed(context, reason) {
  try {
    dispatch(codeVerificationFailed(reason));
    console.error(reason);
  } catch (ex) {
    console.error(ex);
  }
}
